import React from 'react';
import styles from './styles.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

export default class BypassBlock extends React.Component {
  render() {
    return (
      <ol className={cx('bypassblock')}>
        <li><a href="#main-navigation">zur Hauptnavigation springen</a></li>
        <li><a href="#main-content">zum Hauptinhalt springen</a></li>
        <li><a href="#footer">zu den Kontaktinformationen springen</a></li>
      </ol>
    );
  }
}
